export default __webpack_public_path__ + "static/media/memberIcon.d5f5de2e.svg";